import { render, staticRenderFns } from "./GenericComponent.vue?vue&type=template&id=9975f33c&scoped=true"
import script from "./GenericComponent.vue?vue&type=script&lang=js"
export * from "./GenericComponent.vue?vue&type=script&lang=js"
import style0 from "./GenericComponent.vue?vue&type=style&index=0&id=9975f33c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975f33c",
  null
  
)

export default component.exports